import { installedItems } from "@p0security/shared/install/installed";
import { AzureIntegration } from "@p0security/shared/integrations/resources/azure/types";
import { size } from "lodash";
import { Link } from "react-router-dom";

import { FrontendInstallContext } from "../../../../install/types.ts";

export const appRegistrationPreqMessages = async (
  context: FrontendInstallContext<AzureIntegration>
) => {
  if (!size(installedItems("azure-app", context.config))) {
    return (
      <div>
        Requires installed &quot;
        <Link to={"./azure-app"}>Azure App Registration</Link>
        &quot; component
      </div>
    );
  }

  return undefined;
};
